import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import NotFound from "components/NotFound";
import { AdminSettings } from "features/admin-settings";
import { AuditLog } from "features/audit-log";
import { RegisterForm, LoginForm, RequireAuth } from "features/auth";
import { KanbanBoard } from "features/kanban-board";
import { ProjectDashboard } from "features/project-dashboard";
import { ProjectManagement } from "features/project-management";
import { Welcome } from "features/user";
import { Notifications } from "features/notifications";
import NotificationSettingsPage from "features/notification-settings";
import UserProfile from "features/user-settings/components/UserProfile";
import { Client } from "features/client";
import { Employees } from "features/employees";
import Holiday from "features/holiday";
import AttendanceEmployee from "features/attendance-employees";
import Attendance from "features/attendance";
import LeaveRequest from "features/leaveRequest";
import Department from "features/department";
import MyLeaveRequest from "features/leave";
import Tickets from "features/tickets";
import TicketDetail from "features/ticket-detail";
import ClientProfile from "features/client-profile";
import ProjectDetail from "features/project-detail";
import AdminDashboard from "features/superadmin-dasboard";
import UserProfileView from "features/user-profile";
import Chat from "features/chat";
import MeetingManagement from "features/meeting";
import AdminDashboardPanel from "features/adminDashboard";
import EmployeeDashboardPanel from "features/employee-dashboard";
import AttendanceEmployeeDashboard from "features/attendance-employee";
import AttendanceAdmin from "features/attendance-admin";
import LeaveEmployees from "features/leave-employees";
import LeaveConfig from "features/leave-configuration";
import AdminLeave from "features/admin-leave";
import AttendanceDashboardMain from "features/attendance-dashboard";
import LeaveReport from "features/leave-reports";
import AttendanceReport from "features/attendance-reports";
import RoleFeature from "features/role";
import PermissionsTable from "features/permission";
import UserFeature from "features/users";
import CalendarViewApp from "features/calendar";
import LeaveHistoty from "features/leave-history";
import PrivacyPolicy from "features/privacy-policy";
import ProgramFeature from "features/program";
import { AllEmployees } from "features/all-employees";
// import AllEmployees from "features/all-employees";

// import AdminDashboardPanel from "features/adminDashboard/adminDashboard";
import DirectorDashboard from "features/director-dashboard/DirectorDashboard";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/register" element={<RegisterForm />} />
      <Route path="/login" element={<LoginForm />} />
      <Route path="/welcome" element={<Welcome />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route element={<RequireAuth />}>
        <Route
          path="/"
          element={<Navigate to="/attendance-dashboard" replace />}
        />
        <Route path="/director-dashboard" element={<DirectorDashboard />} />
        <Route path="/all-employees" element={<AllEmployees />} />
        <Route
          path="/attendance-employee"
          element={<AttendanceEmployeeDashboard />}
        />
        <Route path="/leave-employees" element={<LeaveEmployees />} />
        <Route
          path="/attendance-dashboard"
          element={<AttendanceDashboardMain />}
        />
        <Route path="/admin-leave" element={<AdminLeave />} />
        {/* <Route path="/help-us" element={<HelpUsBox />} /> */}
        <Route path="/leave-configuration" element={<LeaveConfig />} />
        <Route path="/dashboard/:projectId" element={<ProjectDashboard />} />
        <Route path="/projects/:projectId" element={<KanbanBoard />} />
        <Route path="/project-management" element={<ProjectManagement />} />
        <Route path="/admin-settings" element={<AdminSettings />} />
        <Route path="/audit-log" element={<AuditLog />} />
        <Route path="/user-settings/:userid" element={<UserProfile />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route
          path="/notification-settings"
          element={<NotificationSettingsPage />}
        />
        <Route path="/client" element={<Client />} />
        <Route path="/employees" element={<Employees />} />
        <Route path="/user-profile/:userid" element={<UserProfileView />} />
        <Route path="/holiday" element={<Holiday />} />
        <Route path="/attendance-employees" element={<AttendanceEmployee />} />
        <Route path="/attendance-admin" element={<AttendanceAdmin />} />
        <Route path="/attendance" element={<Attendance />} />
        <Route path="/leave-request" element={<LeaveRequest />} />
        <Route path="/leave" element={<MyLeaveRequest />} />
        <Route path="/tickets" element={<Tickets />} />
        <Route path="/ticket-detail" element={<TicketDetail />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/superadmin-dashboard" element={<AdminDashboard />} />
        <Route path="/department" element={<Department />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/adminDashboard" element={<AdminDashboardPanel />} />
        <Route path="/leave-reports" element={<LeaveReport />} />
        <Route path="/attendance-reports" element={<AttendanceReport />} />
        <Route path="/role" element={<RoleFeature />} />
        <Route path="/permission" element={<PermissionsTable />} />
        <Route path="/users" element={<UserFeature />} />
        <Route path="/calendar" element={<CalendarViewApp />} />
        <Route path="/leave-history" element={<LeaveHistoty />} />
        <Route
          path="/employee-dashboard"
          element={<EmployeeDashboardPanel />}
        />
        <Route path="/program" element={<ProgramFeature />} />
        <Route path="/meeting" element={<MeetingManagement />} />
        <Route path="/client-profile/:clientId" element={<ClientProfile />} />
        <Route
          path="/project-detail/:projectId/:userId"
          element={<ProjectDetail />}
        />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default AppRoutes;
